import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { CButton, CCard, CModal, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'

import moment from 'moment'
import { checkPermissions, convertDuration, getThumbnail, raiseToast } from '../../utils/helper'
import { GlobalContext } from '../../context/GlobalState'
import { PERMISSIONS } from '../../utils/permissions'
// import SearchTable from 'src/components/searchTable'
import useAxios from 'axios-hooks'
import {
  CONTENT_LIST_API,
  CONTENT_LIST_FILTER_API,
  SUBSCRIPTION_API,
  ARTIST_LIST_API,
  META_DATA_URL,
} from '../../utils/urls'
import { AppContext } from '../../context/app'
import { isEmpty, isArray, capitalize } from 'lodash'
import ContentShareModal from './contentShareModal'
import InfiniteScroll from 'react-infinite-scroll-component'
import BasicDisplayCard from 'src/components/cards/basicDisplayCard'
import AssetFilter from '../AssetManager/AssetFilter'
import GridViewIcon from '../../../assets/Content-Icons/Svgs/grid-view-icon.svg'
import ListViewIcon from '../../../assets/Content-Icons/Svgs/list-view-icon.svg'
import EditIcon from '../../../assets/edit-svg-black.svg'
import EyeIcon from '../../../assets/eye-black-icon.svg'
import ShareIcon from '../../../assets/share-sm-icon.svg'
import TrashIcon from '../../../assets/trash-icon-black.svg'
import PreviewDetails from '../AssetManager/PreviewDetails'
import CustomTileCard from 'src/components/cards/customTileCard'

const ContentListing = () => {
  const [contentData, setContentData] = useState([])
  const [deleteContentId, setDeleteContentId] = useState('')
  const [searchText, setSearchText] = useState('')
  const [deleteModal, setDeleteModal] = useState(false)
  const [shareModalData, setShareModalData] = useState({})
  const { userSessionObj } = useContext(GlobalContext)
  const { setLoader, accountObj } = useContext(AppContext)
  const [page, setPage] = useState(1)
  const [listView, setListView] = useState(false)
  const [previewContent, setPreviewContent] = useState({})
  const [filters, setFilters] = useState([])
  const [filterPayloadObj, setFilterPayloadObj] = useState({})
  const [categoryFilter, setCategoryFilter] = useState([])
  const [subCategoryFilter, setSubCategoryFilter] = useState([])
  const [subscriptionFilter, setSubcriptionFilter] = useState([])
  const [PPVFilter, setPPVFilter] = useState([])
  const [artistFilter, setArtistFilter] = useState([])
  const [categoryMasterData, setCategoryMasterData] = useState([])
  const [subCategoryMasterData, setSubCategoryMasterData] = useState([])
  const [subscriptionMasterData, setSubscriptionMasterData] = useState([])
  const [ppvMasterData, setPPVMasterData] = useState([])
  const [artistData, setArtistData] = useState([])
  const [basicInfo, setBasicInfo] = useState([])

  const history = useHistory()
  const language = localStorage.getItem('language')
  const defaultLangCheck = language === accountObj?.default_language
  const createAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.CONTENT.CREATE) &&
    defaultLangCheck

  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.CONTENT.UPDATE,
  )
  const deleteAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.CONTENT.DELETE,
  )

  const [{ data: categories, loading: categoriesLoading }] = useAxios({
    url: `${META_DATA_URL}/system`,
    method: 'get',
  })

  const [{ data: subscriptionList, loading: subscriptionListLoading }] = useAxios({
    url: SUBSCRIPTION_API + '?type=normal',
    method: 'get',
  })

  const [{ data: ppvList, loading: ppvListLoading }] = useAxios({
    url: SUBSCRIPTION_API + '?type=ppv',
    method: 'get',
  })

  const [{ data: artist, loading: artistLoading }] = useAxios({
    url: ARTIST_LIST_API,
    method: 'get',
  })

  const [{ data: contentList, loading: contentListLoading }, contentListCall] = useAxios(
    {
      url: CONTENT_LIST_FILTER_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: contentDelete, loading: contentDeleteLoading }, contentDeleteCall] = useAxios(
    {
      url: CONTENT_LIST_API,
      method: 'delete',
    },
    { manual: true },
  )

  useEffect(() => {
    if (categories && categories.success) {
      setCategoryMasterData(
        categories?.data?.filter((info) => info.status && info.type === 'category'),
      )
      setSubCategoryMasterData(
        categories?.data?.filter((info) => info.status && info.type === 'sub_category'),
      )
    }
  }, [categories])

  useEffect(() => {
    if (subscriptionList && subscriptionList.success) {
      setSubscriptionMasterData(subscriptionList?.data?.filter((info) => info.status))
    }
  }, [subscriptionList])

  useEffect(() => {
    if (ppvList && ppvList.success) {
      setPPVMasterData(ppvList?.data?.filter((info) => info.status))
    }
  }, [ppvList])

  useEffect(() => {
    if (artist && artist.success) {
      setArtistData(artist?.data?.filter((info) => info.status))
    }
  }, [artist])

  useEffect(() => {
    setFilterPayloadObj({
      system_defined: [
        {
          key: 'category',
          name: 'Category',
          filter_type: 'AND',
          operator: 'eq',
          values: categoryFilter,
        },
        {
          key: 'sub_categories',
          name: 'Sub-Category',
          filter_type: 'AND',
          operator: 'eq',
          values: subCategoryFilter,
        },
        {
          key: 'active_subscription',
          name: 'Subscription',
          filter_type: 'AND',
          operator: 'eq',
          values: subscriptionFilter,
        },
        {
          key: 'active_ppv',
          name: 'PPV',
          filter_type: 'AND',
          operator: 'eq',
          values: PPVFilter,
        },
        {
          key: 'artists',
          name: 'Artist',
          filter_type: 'AND',
          operator: 'eq',
          values: artistFilter,
        },
      ],
      search_text: searchText,
    })
  }, [searchText, artistFilter, PPVFilter, subscriptionFilter, subCategoryFilter, categoryFilter])

  useEffect(() => {
    if (filters.filter((info) => info.checkedState !== '').length === 0) {
      setFilters([
        {
          title: 'Category',
          type: 'checkbox',
          checkedState: '',
          options: categoryMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            //  index, setStateFunc, checked, value
            onFilterChange(0, setCategoryFilter, checked, value)
          },
        },
        {
          title: 'Sub Category',
          type: 'checkbox',
          checkedState: '',
          options: subCategoryMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(1, setSubCategoryFilter, checked, value)
          },
        },
        {
          title: 'Subscription',
          type: 'checkbox',
          checkedState: '',
          options: subscriptionMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(2, setSubcriptionFilter, checked, value)
          },
        },
        {
          title: 'PPV',
          type: 'checkbox',
          checkedState: '',
          options: ppvMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(3, setPPVFilter, checked, value)
          },
        },
        {
          title: 'Artists',
          type: 'checkbox',
          checkedState: '',
          options: artistData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(4, setArtistFilter, checked, value)
          },
        },
      ])
    }
  }, [categoryMasterData, subCategoryMasterData, subscriptionMasterData, ppvMasterData, artistData])

  const filterIntialValue = [
    {
      title: 'Category',
      type: 'checkbox',
      checkedState: '',
      options: categoryMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        //  index, setStateFunc, checked, value
        onFilterChange(0, setCategoryFilter, checked, value)
      },
    },
    {
      title: 'Sub Category',
      type: 'checkbox',
      checkedState: '',
      options: subCategoryMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(1, setSubCategoryFilter, checked, value)
      },
    },
    {
      title: 'Subscription',
      type: 'checkbox',
      checkedState: '',
      options: subscriptionMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(2, setSubcriptionFilter, checked, value)
      },
    },
    {
      title: 'PPV',
      type: 'checkbox',
      checkedState: '',
      options: ppvMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(3, setPPVFilter, checked, value)
      },
    },
    {
      title: 'Artists',
      type: 'checkbox',
      checkedState: '',
      options: artistData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(4, setArtistFilter, checked, value)
      },
    },
  ]

  useEffect(() => {
    contentListCall({
      data: {
        filters: filterPayloadObj,
        page: page,
        order_by: 'modified_date',
        page_size: 36,
      },
    })
  }, [])

  useEffect(() => {
    setLoader(
      contentListLoading ||
        contentDeleteLoading ||
        categoriesLoading ||
        artistLoading ||
        subscriptionListLoading ||
        ppvListLoading,
    )
  }, [
    contentListLoading,
    contentDeleteLoading,
    categoriesLoading,
    artistLoading,
    subscriptionListLoading,
    ppvListLoading,
  ])

  useEffect(() => {
    if (contentList && contentList.success) {
      page === 1
        ? setContentData(contentList.data)
        : setContentData((contentData) => [...contentData, ...contentList.data])
    }
  }, [contentList])

  useEffect(() => {
    if (contentDelete && contentDelete.success) {
      setDeleteModal(false)
      raiseToast('success', 'Deleted successfully')
      setPage(1)
      contentListCall({
        data: {
          filters: filterPayloadObj,
          page: 1,
          order_by: 'modified_date',
          page_size: 36,
        },
      })
    }
  }, [contentDelete])

  useEffect(() => {
    setBasicInfo([
      {
        property: 'Title',
        value: previewContent.title,
      },
      {
        property: 'Description',
        value: previewContent?.description,
      },
      {
        property: 'Content Type',
        value: previewContent?.video_type,
      },
      {
        property: 'File Type',
        value: previewContent?.asset_type,
      },

      {
        property: 'Category',
        value: !isEmpty(previewContent?.category)
          ? [...previewContent?.category].map((info) => info.name).toString()
          : '',
      },
      { property: 'Status', value: capitalize(String(previewContent?.publish_policy)) },
      {
        property: 'Monetization',
        value:
          previewContent?.active_subscription?.length > 0 ||
          previewContent?.active_ppv_subscription?.length > 0
            ? 'Paid'
            : 'Free',
      },
      {
        property: 'Publish Time',
        value: moment(previewContent?.publish_time).format('DD MMM YYYY'),
      },
      { property: 'Permalink', value: 'N/A' },
    ])
  }, [previewContent])

  const handleEdit = (id) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }

    history.push({ pathname: '/content-create', state: { id, isEdit: true } })
  }
  const handleAdd = () => {
    if (!createAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    history.push({ pathname: '/content-create' })
  }

  const handleDeleteContent = (id) => {
    if (!deleteAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setDeleteContentId(id)
    setDeleteModal(true)
  }

  const handleDelete = () => {
    contentDeleteCall({
      params: {
        content_id: deleteContentId,
      },
    })
  }

  const onFilterChange = (index, setStateFunc, checked, value) => {
    if (checked) {
      setStateFunc((prev) => {
        handleFilterChange(index, [...prev, value])
        return [...prev, value]
      })
    } else {
      setStateFunc((prev) => {
        handleFilterChange(
          index,
          [...prev].filter((type) => type !== value),
        )
        return [...prev].filter((type) => type !== value)
      })
    }
  }

  const handleFilterChange = (index, value) => {
    setFilters((prev) => {
      prev[index] = { ...prev[index], checkedState: value }
      return [...prev]
    })
  }

  const handleSearch = (value) => {
    setPage(1)
    setSearchText(value)
    contentListCall({
      data: {
        filters: { ...filterPayloadObj, search_text: value },
        page: 1,
        order_by: 'modified_date',
        page_size: 36,
      },
    })
  }

  const handleNextPage = () => {
    contentListCall({
      data: {
        filters: filterPayloadObj,
        page: page + 1,
        order_by: 'modified_date',
        page_size: 36,
      },
    })
    setPage((page) => page + 1)
  }

  const applyFilter = () => {
    setPage(1)
    contentListCall({
      data: {
        filters: filterPayloadObj,
        page: 1,
        order_by: 'modified_date',
        page_size: 36,
      },
    })
  }

  const resetFilters = () => {
    setFilters(filterIntialValue)
    setCategoryFilter([])
    setSubCategoryFilter([])
    setSubcriptionFilter([])
    setPPVFilter([])
    setArtistFilter([])
    setPage(1)
    contentListCall({
      data: {
        filters: { search_text: searchText },
        page: 1,
        order_by: 'modified_date',
        page_size: 36,
      },
    })
  }

  const getStatus = (info) => {
    let todayUTC = moment().utc().format('YYYY-MM-DD[T]HH:mm:ss')
    let statusStr = ''
    if (info?.publish_policy === 'DRAFT') {
      statusStr = 'Draft'
    }
    if (info?.publish_policy === 'IMMEDIATE') {
      statusStr = 'Published'
    }
    if (info?.publish_policy === 'SCHEDULED') {
      statusStr = moment(todayUTC).isBefore(info?.publish_time) ? 'Scheduled' : 'Published'
    }
    return statusStr
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <h4>Content List</h4>
          <p>Following are the contents which are already in your store.</p>
        </div>
        <CButton
          className="text-white px-3"
          onClick={handleAdd}
          disabled={!createAllowed}
          style={{ pointerEvents: 'auto', fontSize: '18px', background: '#20211c' }}
          title={defaultLangCheck ? '' : 'Adding Content Available on Default Language'}
        >
          + Add Content
        </CButton>
      </div>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          padding: '1.42vw 0vw 0',
          margin: '0 auto 3vh',
          width: '100%',
          visibility: 'unset',
          position: 'relative',
        }}
      >
        <h6 style={{ marginRight: 'auto', fontSize: '17px' }}>
          Contents ({contentList?.total} items)
        </h6>
        <AssetFilter
          filters={filters}
          onSearch={handleSearch}
          onApply={applyFilter}
          onClearAll={resetFilters}
          dropdownHeight={'300px'}
          searchStyle={{ background: '#fff' }}
        />
        <div
          className="d-flex justify-content-start align-items-center rounded-1 overflow-hidden"
          style={{ border: '0.5px solid #707070' }}
        >
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              height: '100%',
              backgroundColor: !listView ? '#000' : '#fff',
              padding: 'max(.42vw,8px) .84vw',
              cursor: 'pointer',
            }}
            onClick={() => setListView(false)}
          >
            <img
              src={GridViewIcon}
              alt=""
              className="h-100"
              style={{ filter: !listView ? 'invert(0)' : 'invert(1)' }}
            />
          </div>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              height: '100%',
              backgroundColor: listView ? '#000' : '#fff',
              padding: 'max(.42vw,8px) .84vw',
              cursor: 'pointer',
            }}
            onClick={() => setListView(true)}
          >
            <img
              src={ListViewIcon}
              alt=""
              className="h-100"
              style={{ filter: !listView ? 'invert(0)' : 'invert(1)' }}
            />
          </div>
        </div>
      </div>
      <CCard>
        {!isEmpty(previewContent) && (
          <PreviewDetails
            onClose={() => setPreviewContent({})}
            cardImage={getThumbnail(
              userSessionObj.session_data.cf_domain_name,
              previewContent?.thumbnail?.website?.s3_key,
            )}
            headline="Content Preview"
            subHeadline="Detailed information about the selected Content"
            basicInfo={basicInfo}
            resolutions={previewContent?.source_asset?.progress}
            playIconForVideo={true}
          />
        )}
        <div>
          <div id="scrollableDiv" className="asset-manager-card position-relative">
            <InfiniteScroll
              dataLength={contentData.length} //This is important field to render the next data
              next={handleNextPage}
              hasMore={contentList && contentList.total > page * 36}
              style={{ overflowX: 'hidden' }}
              loader={<p>Loading...</p>}
              className="scrollbar-class"
              height={`65vh`}
              scrollableTarget="scrollableDiv"
            >
              {listView && (
                <div
                  className="d-flex px-2 justify-content-center align-items-center w-100 bg-black text-white position-absolute"
                  style={{
                    fontSize: 'max(0.63vw,10px)',
                    // gap: '0 2.2%',
                    paddingTop: '2px',
                    paddingBottom: '2px ',
                    top: '0',
                    zIndex: '10',
                  }}
                >
                  <div style={{ marginBlockEnd: '0', width: '10%' }} className="text-center mx-2">
                    Thumbnail
                  </div>
                  <div style={{ width: '90%' }} className="d-flex align-items-center">
                    <div style={{ marginBlockEnd: '0', width: '25%' }}>Title</div>
                    <div style={{ marginBlockEnd: '0', width: '10%' }}>Duration</div>
                    <div style={{ marginBlockEnd: '0', width: '12%' }}>Status</div>
                    <div style={{ marginBlockEnd: '0', width: '12%' }}>Released Date</div>
                    <div style={{ marginBlockEnd: '0', width: '11%' }}>Content Type</div>
                    <div style={{ marginBlockEnd: '0', width: '25%' }}>Category</div>
                    <div style={{ width: '5%' }}></div>
                  </div>
                </div>
              )}
              <div
                className="d-flex flex-wrap"
                style={{
                  gap: listView ? '1.2vw 0' : '1.2vw 1.6%',
                  padding: listView ? '30px 8px 20px 8px' : '20px 8px 20px 8px',
                }}
              >
                {!isEmpty(contentData)
                  ? contentData.map((info, index) => {
                      return listView ? (
                        <CustomTileCard
                          cardImage={getThumbnail(
                            userSessionObj.session_data.cf_domain_name,
                            info?.thumbnail?.website?.s3_key,
                          )}
                          textData={[
                            {
                              name: info?.title,
                              styles: {
                                overflow: 'hidden',
                                fontWeight: '600',
                                fontSize: '14px',
                                width: '25%',
                              },
                            },
                            {
                              name:
                                info.video_type === 'LIVE'
                                  ? info?.live_expiry_time
                                    ? moment(info?.live_expiry_time).diff(
                                        moment(info?.publish_time),
                                        'hours',
                                      ) +
                                      'h ' +
                                      (moment(info?.live_expiry_time).diff(
                                        moment(info?.publish_time),
                                        'minutes',
                                      ) %
                                        60) +
                                      'm'
                                    : 'N/A'
                                  : info?.source_asset?.file_metadata?.duration
                                  ? convertDuration(info?.source_asset?.file_metadata?.duration)
                                  : 'N/A',
                              styles: { width: '10%' },
                            },
                            {
                              name: getStatus(info),
                              styles: { width: '12%' },
                            },
                            {
                              name: moment(info?.publish_time).format('DD MMM YYYY'),
                              styles: { width: '12%' },
                            },
                            { name: info?.video_type, styles: { width: '11%' } },
                          ]}
                          key={index}
                          categories={
                            isArray(info?.category)
                              ? info?.category.map((info) => info.name)
                              : [info?.category.name]
                          }
                          categoriesWidth="25%"
                          actionButtonOptions={[
                            {
                              name: 'Preview',
                              btnFunction: () => setPreviewContent(info),
                              logo: (
                                <div className="flex mr-1">
                                  <img style={{ width: '10px' }} src={EyeIcon} />
                                </div>
                              ),
                            },
                            {
                              name: 'Share',
                              btnFunction: () => setShareModalData(info),
                              logo: (
                                <div className="flex mr-1">
                                  <img style={{ width: '10px' }} src={ShareIcon} />
                                </div>
                              ),
                            },
                            {
                              name: 'Edit',
                              btnFunction: () => handleEdit(info?._id),
                              logo: (
                                <div className="flex mr-1">
                                  <img style={{ width: '10px' }} src={EditIcon} />
                                </div>
                              ),
                            },
                            {
                              name: 'Delete',
                              btnFunction: () => handleDeleteContent(info?._id),
                              logo: (
                                <div className="flex mr-1">
                                  <img style={{ width: '10px' }} src={TrashIcon} />
                                </div>
                              ),
                            },
                          ]}
                          actionButtonWidth="5%"
                        />
                      ) : (
                        <BasicDisplayCard
                          cardImage={getThumbnail(
                            userSessionObj.session_data.cf_domain_name,
                            info?.thumbnail?.website?.s3_key,
                          )}
                          playIconForVideo={true}
                          fileName={info?.title}
                          leftText={info?.video_type}
                          rightText={moment(info?.publish_time).format('DD MMM YYYY')}
                          key={index}
                          actionButtonOptions={[
                            {
                              name: 'Preview',
                              btnFunction: () => setPreviewContent(info),
                              logo: (
                                <div className="flex mr-1">
                                  <img style={{ width: '10px' }} src={EyeIcon} />
                                </div>
                              ),
                            },
                            {
                              name: 'Share',
                              btnFunction: () => setShareModalData(info),
                              logo: (
                                <div className="flex mr-1">
                                  <img style={{ width: '10px' }} src={ShareIcon} />
                                </div>
                              ),
                            },
                            {
                              name: 'Edit',
                              btnFunction: () => handleEdit(info?._id),
                              logo: (
                                <div className="flex mr-1">
                                  <img style={{ width: '10px' }} src={EditIcon} />
                                </div>
                              ),
                            },
                            {
                              name: 'Delete',
                              btnFunction: () => handleDeleteContent(info?._id),
                              logo: (
                                <div className="flex mr-1">
                                  <img style={{ width: '10px' }} src={TrashIcon} />
                                </div>
                              ),
                            },
                          ]}
                        />
                      )
                    })
                  : !contentListLoading && <h5 className="no-data-text">No Content Found!</h5>}
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </CCard>
      {!isEmpty(shareModalData) && (
        <ContentShareModal detail={shareModalData} onClose={() => setShareModalData({})} />
      )}
      <CModal visible={deleteModal} alignment="center">
        <CModalHeader className="border-0">
          <CModalTitle>Are you sure you want to Delete ?</CModalTitle>
        </CModalHeader>
        <CModalFooter className="border-0">
          <p className="mx-3 cursor-pointer" onClick={() => setDeleteModal(false)}>
            Cancel
          </p>
          <CButton
            className="text-white"
            style={{ background: '#20211c' }}
            color="info"
            onClick={handleDelete}
          >
            Yes
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ContentListing
